module.exports = "\r\n<div class=\"row content-break col-xs-12\">\r\n    <div class=\"alert\"\r\n         [class.alert-success]=\"notify.isSuccess\"\r\n         [class.alert-info]=\"notify.isInfo\"\r\n         [class.alert-warning]=\"notify.isWarning\"\r\n         [class.alert-danger]=\"notify.isError\"\r\n         [hidden]=\"!notify.isDisplaying\">\r\n        <strong>{{notify.message}}</strong>\r\n    </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./app/notification/notification.component.html
 ** module id = 640
 ** module chunks = 0
 **/